import axiosInstance from "../instance/axiosInstance";

class AuthApi {
  static async login(credentials) {
    try {
      const response = await axiosInstance.post(
        "/authentication/login",
        credentials
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async logout() {
    try {
      const response = await axiosInstance.get("/authentication/logout");
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async signupStepOne(credentials) {
    try {
      const response = await axiosInstance.post(
        "/authentication/register-step-1",
        credentials
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async signupStepTwo(credentials) {
    try {
      const response = await axiosInstance.post(
        "/authentication/register-step-2",
        credentials,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async reqPasswordReset(email) {
    try {
      const response = await axiosInstance.post(
        "/authentication/reset-password-request",
        email
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async resetPassword(formData) {
    try {
      const response = await axiosInstance.post(
        "/authentication/reset-password",
        formData
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async loginWithPhone(phone) {
    try {
      const response = await axiosInstance.post(
        "/authentication/send-otp",
        phone
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async verifyOtp(queryData) {
    try {
      const response = await axiosInstance.post("/verify-otp", queryData);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getAuthenticatedUser() {
    try {
      const response = await axiosInstance.get(
        "/authentication/get-authenticated-user"
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getBankInfo() {
    try {
      const response = await axiosInstance.get(
        "/authentication/platform-settings"
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getPlanInfo(id, type) {
    let url = `/plans/detail/${id}`;
    if (type) {
      url += `?type=${type}`;
    }
    try {
      const response = await axiosInstance.get(url);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async checkPromoCode(code) {
    let url = `/authentication/check-promotion/${code}`;
    try {
      const response = await axiosInstance.get(url);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
}

export default AuthApi;
